define('app-SearchResults/modules/urlWatcher/module',['./settings', '../../../app/utilities/urlKey', '../../../app-Search/core/service'],
        function (settings, UrlKey, Service) {

            // This guy exists to keep the search service and the URL in sync.  Changes to one need to be reflected in the other.

            return {
                initialise: function (globalSettings) {

                    var lastUrl = '';
                    var lastSearch = [];
                    var urlKey = new UrlKey();
                    var service = new Service(globalSettings.searchStorageKey);
                    var key = '';
                    var urlChecked = false;
                    window.waitForUrlChecker = true;

                    // Check the URL periodically to look for updates.
                    setInterval(function () {
                        urlChecked = true;
                        var currentUrl = urlKey.Get(globalSettings.searchUrlKey);
                        if (currentUrl && currentUrl !== lastUrl) {
                            lastUrl = currentUrl;

                            var lastUrlDecoded = decodeURIComponent(lastUrl);

                            lastSearch = JSON.parse(lastUrlDecoded);

                            service.removeAllTerms().addTerms(lastSearch).Notify(key);
                        }
                        
                        if (currentUrl && currentUrl.length > 0) window.waitForUrlChecker = false;

                    }, 0);

                    // Subscribe to changes in the search service so that we get notified
                    // of changes here and can reflect them to the URL.
                    key = service.observe(function () {
                        // The search query in the URL needs first go, so we wait until it's been inspected.
                        if (!urlChecked) return;
                        lastSearch = service.allTerms();
                        var newUrl = JSON.stringify(lastSearch);

                        newUrl = newUrl.replace(/\s{2,}/g, ' ');
                        if (newUrl !== lastUrl) {
                            urlKey.Set(globalSettings.searchUrlKey, newUrl);
                            lastUrl = newUrl;
                        //    self.Service.createCookie("SearchTerms", lastUrl, 120); //save to cookie too
                        }
                    });

                    window.loadedModules('Results list (URL Watcher)');
                   
                }
            };
        });
